import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import { comments } from '@/mocks/home';
import SectionHeading from './SectionHeading';

interface CommentZoneProps {
  notify: (msg: string) => void;
}

export default function CommentZone({ notify }: CommentZoneProps) {
  const [liked, setLiked] = useState<string[]>([]);

  const toggleLike = (id: string) => {
    setLiked((prev) => (prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]));
  };

  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-8 md:py-16">
        <Reveal>
          <SectionHeading
            kicker="吃瓜现场"
            icon="ri-chat-smile-3-line"
            title="吃瓜现场 · 网友热评"
            desc="下载之后大家都会顺手留两句，哪一包值得先取、哪个平台速度更快，看评论比看目录还快。"
            action={
              <button
                type="button"
                onClick={() => notify('评论功能为演示展示，暂未开放提交')}
                className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-edit-2-line"></i>
                </span>
                我要发言
              </button>
            }
          />
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {comments.map((comment, index) => {
            const isLiked = liked.includes(comment.id);
            return (
              <Reveal key={comment.id} delay={index * 60}>
                <article className="flex h-full flex-col rounded-xl border border-background-200 bg-background-50 p-5">
                  <div className="flex items-center gap-3">
                    <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-bold text-background-50 ${comment.avatarTone}`}>
                      {comment.user.slice(0, 1)}
                    </span>
                    <div className="min-w-0">
                      <p className="truncate text-sm font-medium text-foreground-950">{comment.user}</p>
                      <p className="text-[11px] text-foreground-400">{comment.level} · {comment.time}</p>
                    </div>
                  </div>
                  <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">{comment.content}</p>
                  <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                    <button
                      type="button"
                      onClick={() => toggleLike(comment.id)}
                      className={`flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md px-2.5 py-1.5 text-xs transition-colors ${
                        isLiked ? 'bg-primary-100 text-primary-700' : 'text-foreground-500 hover:bg-background-100'
                      }`}
                    >
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className={isLiked ? 'ri-thumb-up-fill' : 'ri-thumb-up-line'}></i>
                      </span>
                      {comment.likes + (isLiked ? 1 : 0)}
                    </button>
                    <button
                      type="button"
                      onClick={() => notify('已展开这条评论的回复')}
                      className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md px-2.5 py-1.5 text-xs text-foreground-500 transition-colors hover:bg-background-100"
                    >
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className="ri-chat-1-line"></i>
                      </span>
                      回复
                    </button>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}